
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-success",
      function () {
        return require("private-next-pages/order-success/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-success"])
      });
    }
  